//componente per cambiare l'opacità del layer
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import { connect } from 'react-redux';
import {changeOpacity} from '../../../../redux'
import { useEffect } from "react";

const useStyles = makeStyles({
  root: {
    width: 100,
  },
});



 function SliderOpacity(props) {
  const classes = useStyles();
  const opacity = parseInt(props.nodes.opacity)
  var nodes = props.nodes
  
  const [value, setValue] = React.useState(opacity);

  const handleChange = (event, newValue) => {
    

    setValue(newValue);

    // setOpacity(map,props.nome,newValue)
  };
  useEffect(()=>{
    nodes.opacity = value
    props.changeOpacity(nodes)
  },[value])
  return (
    <div className={classes.root}>

          <Slider
            min={0}
            step={0.1}
            max={1}
            disabled={false}
            defaultValue={1}
            value={value} 
          onChange={handleChange} 
          aria-labelledby="continuous-slider" 
          />

    </div>
  );
}
const mapStateToProps = state => {
  return {
      tocSlider: state.tocSlider
  }
}
const mapDispatchToProps = dispatch => {
  return {
    changeOpacity: (opacity) => dispatch(changeOpacity(opacity))
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(SliderOpacity);